<template>
    <a class="btn btn-secondary" :href="route_back">Вернуться</a>
    <div>
        <div>
            <span class="fs-3">
                Контент плейлиста "{{item.name}}":
            </span>
            <div v-for="(device, index) in devices" class="card" style="width: 18rem;">
                <div v-if="device.active">
                    <div class="card-body">
                        <h5 class="card-title">{{device.device_key}}</h5>
                        <a href="" class="btn btn-danger" v-on:click="deleteContent(index)">Удалить</a>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <span class="fs-3">
                Контент не добавленный:
            </span>
            <div v-for="(device, index) in devices" class="card" style="width: 18rem;">
                <div v-if="!device.active">
                    <div class="card-body">
                        <h5 class="card-title">{{device.device_key}}</h5>
                        <a href="" class="btn btn-success" v-on:click="addContent(index)">Добавить</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Playlist from "../../../../models/Playlist";

export default {
    name: "PlaylistDevicesComponent",
    props: {
        route_back: String,
        route_get: String,
        route_device_add: String,
        route_device_del: String,
        item_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            playlist: new Playlist({
                route_get: this.route_get,
                route_device_del: this.route_device_del,
                route_device_add: this.route_device_add
            }),
            item: [],
            devices: []
        }
    },
    methods: {
        getData: async function () {
            let response = await this.playlist.get(this.item_id);
            this.item = response.playlist;
            this.devices = response.devices;
            console.log(this.devices);
        },
        addContent: async function (index) {
            event.preventDefault();
            let result = await this.playlist.addDevice(this.item_id, this.devices[index].id);
            if(result)
            {
                this.devices[index].active = true;
            }
            else
            {
                console.log('error: device_add');
            }
        },
        deleteContent: async function (index) {
            event.preventDefault();
            let result = await this.playlist.delDevice(this.item_id, this.devices[index].id);
            if(result)
            {
                this.devices[index].active = false;
            }
            else
            {
                console.log('error: device_del');
            }
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style scoped>

</style>
